import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './ModelComponentTypeList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelComponentTypeState } from '../../reducers/initialState';
import ModelComponentTypeListTable from './ModelComponentTypeListTable';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';
import { getModelCategoryPermission } from '../../utils';
import SearchBar from '../SearchBar/SearchBar';
import Button from 'react-bootstrap/Button';
import { useNavigate, useParams } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Cookies from 'js-cookie';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import ModelCategoryConfigurationContentTemplate from '../ModelCategoryTab/ModelCategoryConfigurationContentTemplate';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';
import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';


const breadcrumbItems = [
  { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
  { label: <FormattedMessage id="modelComponentTypes.componentTypes" defaultMessage="Component types" /> } // Last item has no href (current page)
];

const ModelComponentTypeList = ({ modelComponentType = { ...initialModelComponentTypeState.modelComponentType }, userProfileWidgets, intl, getModelComponentType, saveModelComponentType, 
  setCurrentPage, setFilterData, userModelCategories, resetModelComponent }) => {
  const history = useNavigate();

  let filter = '';
  let offset = 0;
  let limit = 5;
  let { ModelCategoryId } = useParams();

  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  useEffect(() => {
    getModelComponentType(offset, limit, filter, ModelCategoryId);
  }, [getModelComponentType, ModelCategoryId, offset, limit, filter, modelComponentType.isOpSuccessful]);

   useEffect(() => {
    return () => {
      resetModelComponent({ ...initialModelComponentTypeState });
    }
   }, []);
  const [active, setActive] = useState(false);
  const [modelComponentTypeId, setModelComponentTypeId] = useState(0);


  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const searchHandler = value => {
    setCurrentPage(1);
    filteredResults(value);
  };

  const filteredResults = value => {
    let filteredList = modelComponentType.modelComponentTypeList;

    if (value !== '') {
      filteredList = filteredList.filter(function (item) {
        return item.Name.toLowerCase().includes(value.toLowerCase());
      });
    }

    setFilterData({ filteredResults: { filteredResults: filteredList } });
  };
  // const searchHandler = value => {
  //   if (value === '') {
  //     setIsFilter(false);
  //   } else {
  //     setIsFilter(true);
  //   }
  //   setSearchText(value);

  //   let filteredList = modelComponentType.modelComponentTypeList.filter(function (item) {
  //     return item.Name.toLowerCase().includes(value.toLowerCase());
  //   });

  //   if (filteredList.length > initialLimit) {
  //     setInitialFilteredRecords(filteredList.slice(0, 6));
  //   }
  //   setLocalModelComponentTypes(filteredList);
  // };

  const modelComponentTypesObj = Object.values(modelComponentType.filteredResults);



  const onRemoveModelComponentTypeClick = modelComponentTypeId => {
    setActive(true);
    setModelComponentTypeId(modelComponentTypeId);
  };

  const DeleteModelComponentType = () => {
    let saveData = modelComponentType.selectedModelComponentType;
    saveData.PerformDelete = true;
    saveData.ModelCategoryId = ModelCategoryId;
    saveData.ModelComponentTypeId = modelComponentTypeId;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveModelComponentType(saveData, 'MODELCOMPONENTTYPE_DELETE');
  };

  const handleClose = () => {
    setActive(false);
    setModelComponentTypeId(0);
  };

  const handleConfirm = () => {
    DeleteModelComponentType();
    handleClose();
  };

  const onAddNewClick = () => {
    history(`/operational-setup/model-category-configuration/${ModelCategoryId}/model-component-type`);
  };

  const onChangeModelComponentTypeClick = modelComponentTypeId => {
    history(`/operational-setup/model-category-configuration/${ModelCategoryId}/model-component-type/${modelComponentTypeId}`);
  };
  let isOwner =  getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)
  let messageId = (modelComponentType && modelComponentType.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTTYPE_EDIT');
  const isDeleteAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTTYPE_DELETE');

  const dialogTitle = intl.formatMessage({
    id: 'modelComponentTypes.confirmDelete',
    defaultMessage: 'Are you sure you want to delete model component type?'
  });

  return (
    <div className={s.modelComponentType}>
      {modelComponentType.isLoading && <LoadingSpinner />}
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      {modelComponentType.isLoading && <LoadingSpinner />}
      {modelComponentType.showBanner && (
        <Banner
          failureText={messageText}
          showBanner={modelComponentType.showBanner}
          status={modelComponentType.isOpSuccessful}
          successText={messageText}
        />
      )}
      <ModelCategoryConfigurationContentTemplate selectedPage="manageComponentType" userProfileWidgets={userProfileWidgets}>
        <div className={s.innerComponent} id="model-component-type-section">

          <div className={s.modelComponentTypeHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="modelComponentTypes.componentTypes" defaultMessage="Component types" />
              <span className={s.circle}>
                {modelComponentType.modelComponentTypeList.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.titleRows}>
            <Col sm={6} lg={4}>
              <SearchBar
                searchHandler={searchHandler}
                clearSearchInVisible={false}
                initialText={filter}
                disabled={modelComponentType.showAddEditScreen}
                placeHolderTextId="modelComponentType.search"
              />
            </Col>
            <Col sm={6} lg={8}>
             {isOwner &&
              <Button
                className={s.addbutton}
                style={WidgetVisibility(userProfileWidgets, 'MODELCOMPONENTTYPE_ADDNEW')}
                onClick={onAddNewClick}
                disabled={modelComponentType.showAddEditScreen}
                data-unittest="addModelComponentTypeButton"
              >
                + <FormattedMessage id="modelComponentType.addNew" defaultMessage="ADD NEW" />
              </Button>}
            </Col>
          </Row>

          <div>
            <Pagination
              data={modelComponentTypesObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={modelComponentType.currentPage}
            >
              <ModelComponentTypeListTable
                RemoveModelComponentType={onRemoveModelComponentTypeClick}
                ChangeModelComponentType={onChangeModelComponentTypeClick}
                UpdateAllowed={isUpdateAllowed}
                DeleteAllowed={isDeleteAllowed}
                IsOwner={isOwner}
              />
            </Pagination>
          </div>

        </div>

      </ModelCategoryConfigurationContentTemplate>

    </div>
  );
};


ModelComponentTypeList.propTypes = {
  modelComponentType: PropTypes.object.isRequired,
  userProfileWidgets: PropTypes.object.isRequired,
  getModelComponentType: PropTypes.func.isRequired,
  saveModelComponentType: PropTypes.func.isRequired,
  setModelComponentTypeChange: PropTypes.func.isRequired
};

export default injectIntl(ModelComponentTypeList);
